<template>
  <component :is="activeComponent" />
</template>

<script>
// サービス継続中のコンポーネント
import ServiceOngoing from './index-service-ongoing.vue';
// サービス終了のコンポーネント
import ServiceTermination from './index-service-termination.vue';

export default {
  name: 't-index',
  computed: {
    serviceTermination() {
      return this.$store.state.user.serviceTermination;
    },
    activeComponent() {
      return this.serviceTermination ? ServiceTermination : ServiceOngoing;
    },
  },
};
</script>
